<template>
  <div></div>
</template>

<script>
export default {
  name: 'View'
}
</script>

<style scoped></style>
